<template>
  <div class="function" v-if="functionShow()">
    <van-swipe class="my-swipe" indicator-color="white">
      <van-swipe-item v-for="indexM in Math.ceil(functionData.length/4)" :key="indexM">
        <div class="function-item">
            <div class="item" v-for="index in 4" :key="index" >
              <template v-if="(indexM-1)*4+(index-1)<functionData.length && functionData[(indexM-1)*4+(index-1)].icon && functionData[(indexM-1)*4+(index-1)].title">
                <div class="item-icon">
                  <img :src="functionData[(indexM-1)*4+(index-1)].icon">
                </div>
                <div class="item-icon-name">{{ functionData[(indexM-1)*4+(index-1)].title }}</div>
              </template>
            </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: 'Function',
  props: {
    functionData: {
      type: Array
    }
  },
  methods: {
    functionShow () {
      console.log('this.functionData', this.functionData)
      this.functionData.map(function (item) {
        console.log('functionShow', item)
        if (item.icon || item.icon !== '') {
          return true
        }
      })
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.function{
  padding-top: 17px;
  height: 105px;
  .function-item{
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    .item{
      .item-icon{
        display: flex;
        justify-content: center;
        >img{
          width: 47px;
          height: 47px;
        }
      }
      .item-icon-name{
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #F5F5F5;
        line-height: 19px;
        text-align: center;
      }
    }
  }
}
</style>
